import PropTypes from 'prop-types'
import styled from 'styled-components'

const Section = styled.div`
  background: var(--vo-white);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  padding: 20px 24px;
  margin-bottom: 20px;
`

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`

const SectionTitle = styled.h3`
  font-family: var(--font-secondary);
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--vo-slate);
  margin: 0;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--vo-cloud);
  flex: 1;
`

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 16px;
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ $columns }) => $columns || 3}, 1fr);
  gap: 16px 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const FieldLabel = styled.span`
  font-family: var(--font-secondary);
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--vo-slate);
`

const FieldValue = styled.span`
  font-family: var(--font-body);
  font-size: 14px;
  color: var(--vo-ink);
  word-break: break-word;
`

const DetailSectionField = ({ label, value, children }) => (
  <FieldWrapper>
    <FieldLabel>{label}</FieldLabel>
    {children ? <div>{children}</div> : <FieldValue>{value ?? '—'}</FieldValue>}
  </FieldWrapper>
)

DetailSectionField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
  children: PropTypes.node,
}

export const DetailSection = ({ title, children, columns, actions }) => (
  <Section>
    <SectionHeader>
      <SectionTitle>{title}</SectionTitle>
      {actions && <Actions>{actions}</Actions>}
    </SectionHeader>
    <Grid $columns={columns}>{children}</Grid>
  </Section>
)

DetailSection.Field = DetailSectionField

DetailSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  columns: PropTypes.number,
  actions: PropTypes.node,
}
